module.exports = __webpack_public_path__ + "static/media/toggle-up.cc6c571c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/toggle-up.svg
// module id = 825
// module chunks = 0